<template>
  <v-layout
    :style="`height: calc(100% - ${fillHeightDiff}px);`"
    fill-height
    column
  >
    <Loading :visible="isLoading" />

    <v-layout v-if="isSuccess" column>
      <div v-if="isValidArray(items)">
        <TableInfo :type="type" :pagination="pagination" />

        <div class="table__container">
          <table
            class="table"
            :class="[
              { 'table--hover': hover },
              { 'table--striped': striped }
            ]"
          >
            <THead
              :headers="headers"
              :checkbox="checkbox"
              :dropdownMenu="dropdownMenu"
              :selectedAllLinesCheckbox="selectedAllLinesCheckbox"
              @selectedAllLines="handleSelectedAllLines"
            />

            <TBody
              :items="items"
              :checkbox="checkbox"
              :dropdownMenu="dropdownMenu"
              :activeLine="activeLine"
              :lineClick="lineClick"
              :selectedAllLines="selectedAllLines"
              :clearSelectedLines="clearSelectedLines"
              @updateCheckbox="updateCheckbox"
              @selectedAllLinesCheckbox="handleSelectedAllLinesCheckbox"
              @handleActiveLine="handleActiveLine"
            />
          </table>
        </div>

        <Paginator
          :pagination="pagination"
          :totalVisible="paginatorTotalItems"
          @change="handlePage"
        />
      </div>

      <EmptyState v-else :type="type" />
    </v-layout>

    <Error :visible="isFailed" @tryAgain="tryAgain" />
  </v-layout>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isValidArray } from 'corp-front-vue-commons/src/utils/functions'
import Loading from './Loading'
import EmptyState from 'components/EmptyState'
import TableInfo from './TableInfo'
import THead from './THead'
import TBody from './TBody'
import Paginator from './Paginator'
import Error from './Error'

export default {
  name: 'Table',
  props: {
    type: {
      type: String
    },
    headers: {
      type: Array,
      require: true
    },
    items: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object
    },
    paginatorTotalItems: {
      type: Number
    },
    checkbox: {
      type: Boolean,
      default: false
    },
    dropdownMenu: {
      type: Array,
      default: () => []
    },
    striped: {
      type: Boolean,
      default: false
    },
    hover: {
      type: Boolean,
      default: false
    },
    lineClick: {
      type: Function
    },
    activeLine: {
      type: [String, Number],
      default: null
    },
    clearSelectedLines: {
      type: Boolean
    },
    actions: {
      type: Array,
      default: () => []
    },
    status: {
      type: Number,
      default: STATUS_SUCCESS
    },
    fillHeightDiff: {
      type: Number,
      default: 0
    }
  },
  components: {
    Loading,
    EmptyState,
    TableInfo,
    THead,
    TBody,
    Paginator,
    Error
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    }
  },
  data () {
    return {
      selectedAllLines: false,
      selectedAllLinesCheckbox: false
    }
  },
  methods: {
    isValidArray (val) {
      return isValidArray(val)
    },

    updateCheckbox (ids) {
      this.$emit('updateCheckbox', ids)
    },

    handleSelectedAllLines (boolean) {
      this.selectedAllLines = boolean
    },

    handleSelectedAllLinesCheckbox (boolean) {
      this.selectedAllLinesCheckbox = boolean
    },

    handlePage (page) {
      this.$emit('handlePage', page)
    },

    handleActiveLine (item) {
      this.$emit('handleActiveLine', item)
    },

    tryAgain () {
      this.$emit('tryAgain')
    }
  }
}
</script>

<style lang="scss">
.table__container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table,
.table tr,
.table tr td,
.table tbody,
.table thead,
.table tfoot,
.table tr th,
.table tfoot tr {
  background: none;
  border: none;
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0;
  padding: 0;
}

.table {
  width: 100%;
}

.table--striped {

  .table__body {

    tr {

      &:nth-of-type(odd):not(.table__body__tr--active) {
        background-color: $white;
      }

      &:nth-of-type(even):not(.table__body__tr--active) {
        background-color: $gray-1;
      }
    }
  }
}

.table--hover {

  .table__body {

    > tr {
      transition: background .26s;

      &:not(.table__body__tr--active):hover {
        background-color: rgba($black, 0.015);
      }
    }
  }
}
</style>
